var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFilmPlay = function SvgFilmPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.40002 1H2.60002V3.4H5.40002V1.4H18.6V3.4H21.4V1H22.6V23H21.4V20.6H18.6V22.6H5.40002V20.6H2.60002V23H1.40002V1ZM2.60002 19.4H5.40002V16.6H2.60002V19.4ZM2.60002 15.4H5.40002V12.6H2.60002V15.4ZM2.60002 11.4H5.40002V8.6H2.60002V11.4ZM2.60002 7.4H5.40002V4.6H2.60002V7.4ZM18.6 19.4H21.4V16.6H18.6V19.4ZM18.6 15.4H21.4V12.6H18.6V15.4ZM18.6 11.4H21.4V8.6H18.6V11.4ZM18.6 7.4H21.4V4.6H18.6V7.4ZM6.60002 2.6V21.4H17.4V2.6H6.60002Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.90002 7.34761L15.5463 12L8.90002 16.6524V7.34761ZM10.1 9.6524V14.3476L13.4537 12L10.1 9.6524Z"
  })));
};
export default SvgFilmPlay;